import ThreeDots from '@/images/ThreeDotsBlack.svg';
import theme from '@/theme';
import styled from '@emotion/styled';

export const ThreeDotsCircle = styled.div<{ isActive?: boolean; hideBorder?: boolean }>`
    background-image: url(${ThreeDots});
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    background-color: #fff;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;

    ${({ hideBorder, theme }) => !hideBorder && `border: 1px solid ${theme.colors.black[300]}`};

    ${({ isActive }) => isActive && `background-color: ${theme.colors.black[200]};`}

    :hover {
        background-color: ${({ theme }) => theme.colors.black[200]};
    }
`;
